import React, { Fragment, useEffect, useState } from "react";
import { ApiCall, Colors, FilterApi, Web_url } from "../../common/Const";
import FavoriteBan from "./FavoriteBan";
import Footer from "./Footer";
import Header from "./Header";
import "../../styles/Checkout.css";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Modal from "@mui/material/Modal";
import { images } from "../../common/Images";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import EncryptDecrypt from "../../common/Crypto";
import { toast, ToastContainer } from "react-toastify";
import useRazorpay from "react-razorpay";
import WalletPayConfirmModel from "./WalletPayConfirmModel";
import $ from 'jquery';
import store from "../../redux/Store";
import bagimage from "../../assets/paperbag.png"
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress'
function Checkout() {
  const [selectedValue, setSelectedValue] = useState("a");
  const [open, setOpen] = useState(false);
  const [openLoad, setOpenLoad] = useState(true);
  const [walletOpen, setWalletOpen] = useState(false);
  const Redxcart = useSelector((state) => state.cart);
  const RedxPromo = useSelector((state) => state.promo);
  const loginUser = useSelector((state) => state.login);
  const [appSetting, setAppSetting] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [promoData, setPromoData] = useState("");
  const [promoValue, setPromoValue] = useState(0);
  const [PackingCharge, setPackingCharge] = useState(0);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [cusId, setcusId] = useState(0);
  const [cusdetails, setCusdetails] = useState({});
  const [cusaddresses, setAddresses] = useState([]);
  const [myAddress, setMyAddress] = useState({});
  const [paymentSuccessToken, setPaymentSuccessToken] = useState("");
  const [appLogo, setAppLogo] = useState("");
  const [razorpayKeyId, setRazorpayKeyId] = useState("");
  const [orderId, setOrderId] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const [currency, setCurrency] = useState("");
  const [amtforCoin,setAmountForCoin] = useState(0);
  const Razorpay = useRazorpay();
  const [walletDetails, setwalletDetails] = useState('')
  let payToken = "";
  const DecryptData = async () => {
    let type = "decrypt";
    let format = "text";
    let id = localStorage.getItem("customerId");
    await EncryptDecrypt(id, type, format, (response) => {
      console.log("decode -->", response);
      setcusId(response);
    });
  };

  useEffect(() => {
    DecryptData();
  }, []);
  useEffect(() => {
    handleProfileapi();
    handleAddress();
  }, [cusId]);
  const handleProfileapi = () => {
    console.log(cusId,"cusId")
    const profileParams = { id: cusId == 0 ? loginUser.id :cusId  };
    ApiCall("profileView", profileParams)
      .then((data) => {
        console.log(data);
        if (data.message == "Success.") {
          setCusdetails(data.data);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleAddress = () => {
    const cust_id = { customer_id : cusId == 0 ? loginUser.id :cusId  };
    ApiCall("viewAddress", cust_id)
      .then((data) => {
        console.log(data, "data");
        if (data.message == "Success") {
          setAddresses(data.result);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (cusdetails.length != 0) {
      let address = cusaddresses.find((res) => {
        if (cusdetails.address_id == res.id) {
          return true;
        } else {
          return false;
        }
      });
      if (address != undefined) {
        setMyAddress(address);
      }
      console.log(address, "address", cusaddresses);
    } else {
      console.log(cusaddresses, "cusaddresses");
    }
  }, [cusaddresses, cusdetails]);
  const navigate = useNavigate();

  //   const handleOpen = () => {
  //     navigate('/orderSuccess', {
  //         state: {
  //             id: '#JS0001'
  //         }
  //     });
  //   };
  const data = [
    {
      title: "No of Items",
      val: totalItem,
    },
    {
      title: "Delivery Date",
      val: "28-Dec-2022",
    },
    {
      title: "Items Total",
      val: totalPrice,
    },
    {
      title: "CGST (15%)",
      val: "78.14",
    },
    {
      title: "SGST (15%)",
      val: "78.14",
    },
    {
      title: "Packing Charge",
      val: "110",
    },
    {
      title: "Delivery Charge",
      val: "50",
    },
    {
      title: "Promo Discount",
      val: "0",
    },
  ];
  const walletWithCard =(data)=>{
    


    const options = {
      key: razorpayKeyId, // Enter the Key ID generated from the Dashboard
      amount:data.toFixed() * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency: currency.short_name,
      name: cusdetails.first_name,
      description: "Test Transaction",
      image: images.Hlogo,
      // order_id: "order_9A33XWu170gUtm", //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
      handler: function (response) {
        console.log(response);
        payToken = response.razorpay_payment_id;
        setPaymentSuccessToken(response.razorpay_payment_id);
        $('#close_btn').click()
        orderPlaced("card_wallet");
        
      },
      prefill: {
        name: cusdetails.first_name,
        email: cusdetails.email,
        contact: cusdetails.phone_number,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#126a38",
      },
    };

    const rzp1 = new Razorpay(options);

    rzp1.on("payment.failed", function (response) {
      console.log(response.error);
    });

    rzp1.open();

  }
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    console.log("check -->>", event.target.value);
  };

  const controlProps = (item) => ({
    checked: selectedValue === item,
    onChange: handleChange,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  // useEffect(() => {
  //   console.log(Redxcart, "Redxcarts");
  //   let count = 0;
  //   let total = 0;
  //   let taxTotal = 0;
  //   let taxPercentage = 0;
  //   let packingCharge = 0;
  //   Redxcart.map((res) => {
  //     count += res.quantity;
  //     total += res.order_price * res.quantity;
  //     packingCharge += res.packing_charges;
  //   });
  //   appSetting.map((res) => {
  //     taxPercentage += res.tax_value;
  //     taxTotal += getAllByText(res.tax_value);
  //     console.log(res, "res", taxTotal);
  //   });
  //   setPackingCharge(packingCharge);
  //   setGrandTotal(
  //     total + taxTotal - promoValue + packingCharge + deliveryCharges
  //   );
  //   setTaxPercentage(taxPercentage);
  //   setTotalItem(count);
  //   setTotalPrice(total);
  //   setTaxAmount(taxTotal);
  // }, [Redxcart, appSetting, promoValue, deliveryCharges]);
  function RupeesCal(amount) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  useEffect(() =>{
    console.log(Redxcart,"Redxcarts")
    let count = 0;
    let total = 0;
    let taxTotal = 0;
    let taxPercentage = 0;
    let packingCharge = 0;
    Redxcart.map((res)=>{
      count += res.quantity;
      total += res.order_price * res.quantity;
      packingCharge += res.packing_charges;
    })
    let taxvalue = 0;
    if(RedxPromo.promoValue){
      taxvalue = RedxPromo.promoValue;
      if(RedxPromo.discount_type ==2){
        let taxval = total * RedxPromo.promoDetails / 100;
        console.log(taxval,"taxval");
        setPromoValue(taxval);
        taxvalue = taxval;
      }
    }else{
      taxvalue = 0;
    }
    appSetting.map((res)=>{
      taxPercentage += res.tax_value;
      console.log(total-taxvalue,total,taxvalue,getAllByText(total-taxvalue,res.tax_value))
      taxTotal += getAllByText(total-taxvalue,res.tax_value);
    })
   
    setPackingCharge(packingCharge);
    console.log(total,taxTotal,packingCharge,deliveryCharges,taxvalue);
    setGrandTotal(total+taxTotal+packingCharge+deliveryCharges-taxvalue);
    setTotalItem(count);
    setTotalPrice(total);
    setTaxAmount(taxTotal);
    setTaxPercentage(taxPercentage);
  },[Redxcart,appSetting,promoValue,deliveryCharges])
  useEffect(() => {
    Appsetting();
    Appsettings();
    console.log(RedxPromo, "RedxPromo");
    if (RedxPromo.promoValue) {
      setPromoData({
        discount_type: RedxPromo.discount_type,
        discount_percentage: RedxPromo.promoDetails,
        code: RedxPromo.code,
      });
      setPromoValue(RedxPromo.promoValue);
    }
  }, []);
  const Appsetting = () => {
    ApiCall("checkTax", {})
      .then((data) => {
        console.log(data, "data");
        if (data.message === "Success") {
          setAppSetting(data.result);
        }
      })
      .catch((err) => console.log(err));
  };
  const Appsettings = () => {
    ApiCall("appsetting", {})
      .then((data) => {
        console.log(data, "data");
        if (data.message === "Success") {
          setDeliveryCharges(data.result.delivery_charges);
          setAppLogo(data.result.delivery_charges.app_logo);
          setRazorpayKeyId(data.result.razorpay_key_id);
          setCurrency(data.result.currency);
          setAmountForCoin(data.result.amt_for_coin);
        }
      })
      .catch((err) => console.log(err));
  };
  const getAllByText = (total,val) => {
    let price = (total * val) / 100;
    return price;
  };
  const goToAddress = () => {
    myAddress.address_1 ? navigate("/address") : navigate("/new-address");
  };
  const placeOrder = () => {
    if (
      !cusdetails.address_id ||
      cusdetails.address_id == 0 ||
      cusdetails.address_id == ""
    ) {
      toast.error("Add Address", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }else{

      if (selectedValue == "a") {
        toast.error("Select Payment Type", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (selectedValue == "wallet") {
        console.log(selectedValue, "selectedValue");
        if (cusdetails.wallet_amount < grandTotal) {
       
          $("#wllaetPays").click();
          setWalletOpen(true);
        } else {
          orderPlaced("wallet");
        }
      } else if (selectedValue == "card") {
        console.log(grandTotal);
        const options = {
          key: razorpayKeyId, // Enter the Key ID generated from the Dashboard
          amount: grandTotal.toFixed() * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: currency.short_name,
          name: cusdetails.first_name,
          description: "Test Transaction",
          image: images.Hlogo,
          // order_id: "order_9A33XWu170gUtm", //This is a sample Order ID. Pass the `id` obtained in the response of createOrder().
          handler: function (response) {
            console.log(response);
            payToken = response.razorpay_payment_id;
            setPaymentSuccessToken(response.razorpay_payment_id);
            orderPlaced("card");
          },
          prefill: {
            name: cusdetails.first_name,
            email: cusdetails.email,
            contact: cusdetails.phone_number,
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#126a38",
          },
        };
  
        const rzp1 = new Razorpay(options);
  
        rzp1.on("payment.failed", function (response) {
          console.log(response.error);
        });
  
        rzp1.open();
        console.log(selectedValue, "selectedValue");
      } else if (selectedValue == "cash") {
        orderPlaced("cash");
        console.log(selectedValue, "selectedValue");
      } else {
        console.log(selectedValue, "selectedValue");
      }
    }
    // setOpen(true);
  };
  const orderPlaced = (payment_type) => {
    setShowLoading(true);
    const details = {
      customer_id: cusId == 0  ? loginUser.id :cusId ,
      billing_address: cusdetails.address_id,
      shipping_address: cusdetails.address_id,
      payment_type: payment_type,
      payment_status: 1,
      delivery_charges: deliveryCharges,
      promocode: promoData.code ? promoData.code : "",
      discount_amount: promoValue,
      order_status: 0,
      tax_amount: taxAmount,
      total_amount: payment_type == "wallet" ? 0 : payment_type == "card_wallet" ? Math.abs(cusdetails.wallet_amount - grandTotal)  : grandTotal ,
      products: Redxcart,
      address_id: cusdetails.address_id,
      packing_charge: PackingCharge,
      tax_percentage: taxPercentage,
      pay_id: payToken,
      wallet_amount: payment_type == "wallet" ? grandTotal : payment_type == "card_wallet" ?  cusdetails.wallet_amount : 0
    };
    console.log("order", details);
    FilterApi("order", details)
      .then((data) => {
        setShowLoading(false);
        if (data.message == "Success.") {
          setOpen(true);
          setOrderId(data.result.unique_order_id);
          store.dispatch({
            type: "clearCart",
            payload: {},
          });
          store.dispatch({
            type: "clearPromo",
            payload: {},
          });
        } else {
          toast.error(data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        console.log(data, "data");
      })
      .catch((err) => console.log(err));
    console.log(details, "details");
  };
  const goToMyOrder = () => {
    store.dispatch({type:'clearCart'})
    if(loginUser.id && loginUser.userType == 1){
      store.dispatch({type:'removeData'})
      navigate("/");
    }else{
      navigate("/myorder");
    }
    setOpen(false)
    store.dispatch({
      type: "clearPromo",
      payload: { },
    });
  
  };
  const moveToFilter = () =>{
    navigate("/filter");
  }
    setTimeout(
      function() {
    setOpenLoad(false);
      }
      .bind(this),
      4000
  );
  return (
    <Fragment>
      <ToastContainer />
      <WalletPayConfirmModel res={walletWithCard} amt={Math.abs(cusdetails.wallet_amount - grandTotal)} />
      <Header make={true} />
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
        open={openLoad} 
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div
        style={{ backgroundColor: Colors.bg_color }}
        className="d-flex flex-column"
      >
        {/* <FavoriteBan /> */}
        <div className="container checkout-box">

          {
              Redxcart.length != 0 ?
              <>
              <div style={{width:"250px"}}>
              <div className="row" style={{marginBottom:"20px"}}>
                <div className="col-6">
                  <a href="javascript:history.go(-1)"><button className="btn btn-basic p-0" style={{background: Colors.Base_color,color:"white"}} ><img src={images.left} width={30}/><span style={{position: "relative",left: "-8px",top: "2px"}}>Back</span></button></a>
                </div>
                <div className="col-6" style={{paddingTop: "7px"}}>
                  <h4 className="title">Checkout</h4>
                </div>
              </div>
            </div>
               <div
            className="summary-box"
            style={{ borderBottom: `1px solid ${Colors.Base_color}` }}
          >
            <span className="chck-summary" style={{ color: Colors.Base_color }}>
              Order Summary
            </span>
            <div
              className="d-flex justify-content-start"
              style={{ marginTop: "12px" }}
            >
              <div className="d-flex flex-column chck-list-box">
                <div className="d-flex gap-4">
                  <div className="d-flex flex-column chck-list-box">
                    <Fragment>
                      <span
                        className="chck-list"
                        style={{ color: Colors.Base_color }}
                      >
                        No of Items
                      </span>
                    </Fragment>
                    <Fragment>
                      <span
                        className="chck-list"
                        style={{ color: Colors.Base_color }}
                      >
                        Items of Total
                      </span>
                    </Fragment>
                    {appSetting.map((res) => {
                      return (
                        <Fragment>
                          <span
                            className="chck-list"
                            style={{ color: Colors.Base_color }}
                          >
                            {res.tax_name}({res.tax_value} %)
                          </span>
                        </Fragment>
                      );
                    })}
                    <Fragment>
                      <span
                        className="chck-list"
                        style={{ color: Colors.Base_color }}
                      >
                        Packing charge
                      </span>
                    </Fragment>
                    <Fragment>
                      <span
                        className="chck-list"
                        style={{ color: Colors.Base_color }}
                      >
                        Delivery Charges
                      </span>
                    </Fragment>
                    {promoValue != 0 ? (
                      <Fragment>
                        <span
                          className="chck-list"
                          style={{ color: Colors.Base_color }}
                        >
                          Promo{" "}
                          {promoData.discount_type == 2
                            ? "(" + promoData.discount_percentage + " %)"
                            : null}
                        </span>
                      </Fragment>
                    ) : null}
                    <Fragment>
                      <span
                        className="chck-list"
                        style={{ color: Colors.Base_color }}
                      >
                        Grand Total
                      </span>
                    </Fragment>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column">
                <Fragment>
                  <span className="chck-list" style={{ color: "gray" }}>
                    <span className="chck-colon">:</span> {totalItem}
                  </span>
                </Fragment>
                <Fragment>
                  <span className="chck-list" style={{ color: "gray" }}>
                    <span className="chck-colon">:</span>{currency.symbol} {RupeesCal(totalPrice)}
                  </span>
                </Fragment>
                {appSetting.map((res) => {
                  return (
                    <Fragment>
                      <span className="chck-list" style={{ color: "gray" }}>
                        <span className="chck-colon">:</span>
                        {currency.symbol} {getAllByText(totalPrice-promoValue,res.tax_value).toFixed(2)}
                      </span>
                    </Fragment>
                  );
                })}
                <Fragment>
                  <span className="chck-list" style={{ color: "gray" }}>
                    <span className="chck-colon">:</span>{currency.symbol} {RupeesCal(PackingCharge)}
                  </span>
                </Fragment>
                <Fragment>
                  <span className="chck-list" style={{ color: "gray" }}>
                    <span className="chck-colon">:</span>{currency.symbol} {RupeesCal(deliveryCharges)}
                  </span>
                </Fragment>
                {promoValue != 0 ? (
                  <Fragment>
                    <span className="chck-list" style={{ color: "gray" }}>
                      <span className="chck-colon">:</span>{currency.symbol} - {RupeesCal(promoValue)}
                    </span>
                  </Fragment>
                ) : null}
                <Fragment>
                  <span
                    className="chck-list"
                    style={{ color: "gray", fontWeight: "bold" }}
                  >
                    <span className="chck-colon">:</span>
                    {currency.symbol} {RupeesCal(grandTotal.toFixed(2))}{" "}
                  </span>
                </Fragment>
              </div>
            </div>
          </div>

          <div
            className="chck-add-box d-flex flex-column w-100"
            style={{ borderBottom: `1px solid ${Colors.Base_color}` }}
          >
            <div className="d-flex justify-content-between">
              <span className="add-hd" style={{ color: Colors.Base_color }}>
                Billing & Shipping Address
              </span>
              <div>
                <button
                  className="btn"
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                  }}
                  onClick={goToAddress}
                  disabled={loginUser.userType ? loginUser.userType  == 1 ? true :false : false}
                >
                  {myAddress.address_1 ? "Change" : "Add Address"}
                </button>
              </div>
            </div>
            <div
              className="d-flex flex-column add-text-box"
              style={{ color: "gray" }}
            >
              {myAddress.address_1 ? (
                <>
                  <span>
                    {myAddress.address_1}, {myAddress.city}, {myAddress.state}
                  </span>
                  <span>{myAddress.post_code}, India</span>
                </>
              ) : (
                <p>Add New Address</p>
              )}
            </div>
          </div>

          <div
            className="chck-wallet-box"
            style={{ borderBottom: `1px solid ${Colors.Base_color}` }}
          >
            <span
              className="chck-wallet-hd"
              style={{ color: Colors.Base_color }}
            >
              Wallet Balance
            </span>
            <div
              className="d-flex flex-row align-items-center pt-2"
              style={{ color: Colors.Base_color }}
            >
              <div className="chck-list-box">
                <span className="check-wall-amt chck-list">Wallet Amount</span>
              </div>
              <span className="chck-list">
                <span className="chck-colon">:</span>₹{" "}
                {cusdetails.wallet_amount}
              </span>
            </div>
          </div>

          <div className="pay-tye-box d-flex flex-column">
            <span className="pay-hd" style={{ color: Colors.Base_color }}>
              Payment Option
            </span>
            <div className="d-flex flex-column">
              {/* <div className="d-flex flex-row align-items-center">
                <Radio
                  {...controlProps("e")}
                  sx={{
                    color: "#126a38",
                    "&.Mui-checked": {
                      color: "#126a38",
                    },
                  }}
                />
                <span className="pay-type-text">Online Payment</span>
              </div>
              <div className="d-flex flex-row align-items-center">
                <Radio
                  {...controlProps("e")}
                  sx={{
                    color: "#126a38",
                    "&.Mui-checked": {
                      color: "#126a38",
                    },
                  }}
                />
                <span className="pay-type-text">Card Payment</span>
              </div>
              <div className="d-flex flex-row align-items-center">
                <Radio
                  {...controlProps("e")}
                  sx={{
                    color: "#126a38",
                    "&.Mui-checked": {
                      color: "#126a38",
                    },
                  }}
                />
                <span className="pay-type-text">Wallet Payment</span>
              </div> */}

              <FormControlLabel
                value="card"
                style={{ color: Colors.Base_color }}
                control={
                  <Radio
                    {...controlProps("card")}
                    sx={{
                      color: "#126a38",
                      "&.Mui-checked": {
                        color: "#126a38",
                      },
                    }}
                  />
                }
                label="Online Payment"
              />
              <FormControlLabel
                style={{ color: Colors.Base_color }}
                value="cash"
                control={
                  <Radio
                    {...controlProps("cash")}
                    sx={{
                      color: "#126a38",
                      "&.Mui-checked": {
                        color: "#126a38",
                      },
                    }}
                  />
                }
                label="Cash On Payment"
              />
              {/* <FormControlLabel
                style={{ color: Colors.Base_color }}
                value="wallet"
                disabled={cusdetails.wallet_amount == 0 ? true :false}
                control={
                  <Radio
                    {...controlProps("wallet")}
                    sx={{
                      color: "#126a38",
                      "&.Mui-checked": {
                        color: "#126a38",
                      },
                    }}
                  />
                }
                label="Kamadhenu Wallet"
              /> */}

              <p className="wal-hint" style={{ color: "black" }}>
                For Every purchase of{" "}
                <span style={{ color: Colors.Base_color }}>{currency.symbol} {amtforCoin}</span> of you
                will get{" "}
                <span style={{ color: Colors.Base_color }}>1 Kamadhenu coin</span>
              </p>
              <div>
                <button
                  className="btn btn-con-order btn-lg"
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                  }}
                  onClick={() => placeOrder(true)}
                >
                  Confirm Order
                </button>
              </div>
            </div>
          </div>
          </>
          :
          <>
            <div className="text-center mb-5">
              <img src={bagimage} width={150}/>
              <h1>Your Shopping Bag is Empty!!</h1>
              <p>There is nothing in your bag. Keep adding items now!</p>
              <button
                  type="button"
                  className="btn show-btn py-2 px-4 rounded"
                  style={{ color: Colors.white_color, backgroundColor: Colors.Base_color }}
                  onClick={moveToFilter}
              >START SHOPPING</button>
            </div>
          </>
            }
         

          <div>
            <Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                <div className="cus-model-order d-flex flex-column">
                  {/* <div className="cancel-order-md">
                    <img
                      src={images.cancel}
                      height="25"
                      width="25"
                      alt="cancel"
                      // onClick={() => setOpen(false)}
                      onClick={() => {
                        goToMyOrder();
                      }}
                    />
                  </div> */}

                  <div
                    className="rounded-top d-flex justify-content-center align-items-center suc-box-1"
                    style={{ backgroundColor: "#FE9CB7" }}
                  >
                    <img
                      src={images.tick}
                      width="120"
                      height="120"
                      alt="tick"
                      style={{objectFit: "cover"}}
                    />
                  </div>
                  <div
                    style={{ backgroundColor: "white" }}
                    className="rounded-bottom suc-box-1 d-flex justify-content-center align-items-center flex-column"
                  >
                    <span
                      className="order-su-hd"
                      style={{ color: Colors.Base_color }}
                    >
                      Order Placed Successfully
                    </span>
                    <p className="or-su-sm">Order No : {orderId}</p>
                    <button
                      className="btn px-4"
                      style={{
                        backgroundColor: Colors.Base_color,
                        color: Colors.white_color,
                      }}
                      onClick={() => {
                        goToMyOrder();
                      }}
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
            {/* <Modal
              open={walletOpen}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ height: "100%" }}
              >
                <div className="cus-model-order d-flex flex-column">
                  <div className="cancel-order-md">
                    <img
                      src={images.cancel}
                      height="25"
                      width="25"
                      alt="cancel"
                      onClick={() => setOpen(false)}
                    />
                  </div>

                  <div
                    className=" d-flex justify-content-center align-items-center suc-box-1"
                    style={{ backgroundColor: "white",borderTopLeftRadius:"20px",borderTopRightRadius:"20px" }}
                  >
                    <h2 style={{color:Colors.Base_color}}>Wallet Insufficient Amount!</h2>
                  </div>
                  <div
                    style={{ backgroundColor: "white" }}
                    className="rounded-bottom suc-box-1 d-flex justify-content-center align-items-center flex-column"
                  >
                    <div class="modal-body mdl-body">
                      <div class="mobile-popup">
                        <div class="col-6 textpopup">
                          <p class="paratextpopup">
                              You have insufficient wallet amount, remaining $5139.01 will be debited from the card
                          </p>
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn px-4"
                      style={{
                        backgroundColor: Colors.Base_color,
                        color: Colors.white_color,
                      }}
                      onClick={() => {
                        goToMyOrder();
                      }}
                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            </Modal> */}
            <div>
           
          </div>
          </div>
        </div>
      </div>
      <Footer />
      {showLoading ? (
        <>
          <div id="backdrop" class="backdrop">
            <div class="text-center loading">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </>
      ) : null}
      <button id="wllaetPays" style={{display:"none"}} data-bs-toggle="modal" data-bs-target="#wllaetPay"></button>
    </Fragment>
  );
}

export default Checkout;
